import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d93c99a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chapter" }
const _hoisted_2 = { class: "chapter__inner u-inner u-grid" }
const _hoisted_3 = { class: "chapter__header" }
const _hoisted_4 = { class: "chapter__content" }


const __default__ = {
  name: 'ChapterComponent',
};

import { PropType } from 'vue';
import { Chapter } from '@/types/chapter';
import Content from './Content.vue';
import Intro from './Intro.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: Object as () => Chapter[],
  title: String,
  description: String,
  chapterNumber: Number,
  theme: String as () => 'light' | 'dark',
  transition: Function as PropType<(event: Event, id: string | number) => void>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Intro, {
          title: __props.title,
          chapterNumber: __props.chapterNumber,
          theme: __props.theme
        }, null, 8, ["title", "chapterNumber", "theme"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["chapter__item", item.length > 1 && 'chapter__item--column'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (child, i) => {
              return (_openBlock(), _createBlock(Content, {
                key: i,
                item: child,
                transition: __props.transition
              }, null, 8, ["item", "transition"]))
            }), 128))
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})